'use strict';

/**
 * fetchApp(appId, { App, Includes }) — always resolves the current app
 * instance from the API.
 *
 * my-apps.js's goToApp() navigates via $state.go('root.my-apps.edit-app',
 * { app, appId }), and edit-app.js's getApp() used to special-case
 * $stateParams.app to skip this fetch entirely, resolving with the raw
 * list-row object instead. That row (from the My Apps list's App.find()
 * call) does not reliably carry fields populated only on the single-record
 * endpoint (e.g. the populated appTemplate/integration relations), so the
 * edit form silently failed to render — no fields, no network request —
 * until a hard refresh forced the fetch-fresh branch. Always fetching
 * removes the divergent code path.
 *
 * @param {number|string} appId
 * @param {{App: {findById: Function}, Includes: {apps: object}}} deps
 * @returns {Promise<object>}
 */
function fetchApp(appId, { App, Includes }) {
    return App.findById({ id: appId, filter: Includes.apps }).$promise;
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        fetchApp,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('fetchApp', fetchApp);
}
